import { connect } from "react-redux";

import { finishSession } from "core/slices/session";

import MonitoringActions from "../../../components/pipelineMonitoring/monitoringGraph/InfoDrawer/Root/MonitoringActions";
export default connect((state) => ({}), {
  finishSession,
})(MonitoringActions);
